import React, {useEffect, useState} from 'react';
import axios from 'axios';
import MoonLoader from 'react-spinners/MoonLoader';
import {css} from 'emotion';

import Header from '../components/header';
import Footer from '../components/footer';

import Ok from '../images/tick.svg';
import {useParams} from 'react-router-dom';

const Confirm = () => {
    const [loading, setLoading] = useState();
    const [data, setData] = useState();

    const {dni} = useParams();

    useEffect(() => {
        setLoading(true);
        const getData = async () => {
            try {
                const res = await axios.get(`https://www.ies21.edu.ar/api/v2/colacion-confirma.php?dni=${dni}`);
                const {confirmado, sala} = res.data;
                setData({confirmado, sala});
            } catch (e) {
                console.log(e);
            }
            setLoading(false);
        };
        getData();
    }, [dni]);

    return (
        <>
            <Header siteTitle={`IES21`} />
            <div
                className={css`
                    margin: 0 auto;
                    max-width: 1024px;
                    padding: 0 1.0875rem 1.45rem;
                    display: flex;
                    flex-direction: column;
                    margin-top: -30px;
                `}
            >
                <main>
                    <section
                        className={css`
                            background-color: #fff;
                            padding: 40px 40px 100px 40px;
                            text-align: center;
                        `}
                    >
                        {loading && (
                            <div
                                className={css`
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                `}
                            >
                                <MoonLoader size={40} color={'#00aae4'} loading={loading} />
                            </div>
                        )}

                        {loading || !data ? null : (
                            <>
                                {data.confirmado ? (
                                    <>
                                        <img src={Ok} alt="" />
                                        <h3>¡QUE LINDO VOLVER A VERNOS!</h3>
                                        <p>{data.sala}</p>

                                        <p
                                            className={css`
                                                color: #d42a2a;
                                            `}
                                        >
                                            Recordá que deberás presentarte una hora antes del acto para acreditarte.
                                        </p>

                                        <p>¡Te esperamos!</p>
                                    </>
                                ) : (
                                    <>
                                        <h3>No se pudo confirmar</h3>
                                        <p
                                            className={css`
                                                color: #d42a2a;
                                            `}
                                        >
                                            El dni {dni} no pudo ser confirmado verifica que sea correcto o comunicate al{' '}
                                            <a
                                                className={css`
                                                    color: #d42a2a;
                                                `}
                                                href="https://api.whatsapp.com/send?phone=5493516784879"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                351-6784879
                                            </a>
                                        </p>
                                    </>
                                )}
                            </>
                        )}
                    </section>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Confirm;
